import { format } from "date-fns";

function convertUtcStringToLocal(dateStr: string) {
  const parsedDate = new Date(dateStr);
  const localDate = new Date(
    Date.UTC(
      parsedDate.getFullYear(),
      parsedDate.getMonth(),
      parsedDate.getDate(),
      parsedDate.getHours(),
      parsedDate.getMinutes(),
      parsedDate.getSeconds(),
      parsedDate.getMilliseconds()
    )
  );
  return localDate;
}

export const utcToLocalDate = (isoString: string | null | undefined) =>
  isoString && format(convertUtcStringToLocal(isoString), "dd/MM/yyyy");

export const utcToLocalDateTime = (isoString: string | null | undefined) => {
  return (
    isoString && format(convertUtcStringToLocal(isoString), "dd/MM/yyyy HH:mm")
  );
};
